import type { TeamAnalyticsSource } from "~vue/api/generated/product-teams";

export const TEAM_INTERACTION_SOURCE = {
    MY_PEOPLE: "my_people",
    CALENDAR_SUGGESTION: "calendar_suggestion",
    TEAM_SUGGESTION: "team_suggestion",
    CHAT_TOOL: "chat_tool",
    CHAT_COMPOSER: "chat_composer",
    CHAT_MENTION: "chat_mention",
    PERSON_DETAIL: "person_detail",
    COMBINED_PROFILE: "combined_profile",
    TEAM_PAGE: "team_page",
    TEAM_INVITATION: "team_invitation",
    CSV_UPLOAD: "csv_upload",
    UNKNOWN: "unknown",
} as const satisfies { [Source in TeamAnalyticsSource as Uppercase<Source>]: Source };

export type TeamInteractionSource = TeamAnalyticsSource;

export function teamInteractionRequest(source: TeamInteractionSource, entryPoint?: TeamInteractionSource): RequestInit {
    return { headers: { "X-Team-Source": source, ...(entryPoint ? { "X-Team-Entry-Point": entryPoint } : {}) } };
}
